import { render, staticRenderFns } from "./TabsSelection.vue?vue&type=template&id=ac98995c&scoped=true"
import script from "./TabsSelection.vue?vue&type=script&lang=js"
export * from "./TabsSelection.vue?vue&type=script&lang=js"
import style0 from "./TabsSelection.vue?vue&type=style&index=0&id=ac98995c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac98995c",
  null
  
)

export default component.exports